import { fromJS } from 'immutable'

const initialState = fromJS({
  searchResults: [],
  pending: false,
})

export default function employee(state = initialState, action) {
  switch (action.type) {
    case 'EMP_Q_REQ':
      return state.set('pending', true)

    case 'EMP_Q_SUCC':
      return state
        .set('pending', false)
        .set('searchResults', fromJS(action.payload || []))

    case 'NOTIF_FAIL':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Employees/reducer.js